<div mat-dialog-title>
  <div class="row row--space-between row--valign-center">
    <label class="semi-bold">{{ 'App.CustomerDetails.Labels.CustomerDetails' | translate }}</label>
    <button mat-button (click)="onClose()" class="float-right">
      <span class="icon-x"></span>
    </button>
  </div>
</div>
<div mat-dialog-content>
  <ng-container *ngIf="!isLoading; else loadingCustomerDetails">
    <div class="row display-column-flex align-center">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'App.CustomerDetails.Placeholders.Name' | translate }}</mat-label>
        <input matInput [ngModel]="customer.fullName" readonly />
      </mat-form-field>
    </div>
    <div class="row display-column-flex align-center">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'App.CustomerDetails.Placeholders.PPUID' | translate }}</mat-label>
        <input matInput [ngModel]="customer.generateCustomerId" readonly />
      </mat-form-field>
    </div>
    <div class="row display-column-flex align-center">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'App.CustomerDetails.Placeholders.Email' | translate }}</mat-label>
        <input matInput [ngModel]="customer.email" readonly />
      </mat-form-field>
    </div>
    <div class="row display-column-flex align-center">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'App.CustomerDetails.Placeholders.PhoneNumber' | translate }}</mat-label>
        <input matInput [ngModel]="(customer.mobileNumber ?? customer.homeNumber) | customFormat : 6" readonly />
      </mat-form-field>
    </div>
    <div class="row display-column-flex align-center">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'App.CustomerDetails.Placeholders.AddressLine1' | translate }}</mat-label>
        <input matInput [ngModel]="customer.address1" readonly />
      </mat-form-field>
    </div>
    <div class="row display-column-flex align-center">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'App.CustomerDetails.Placeholders.AddressLine2' | translate }}</mat-label>
        <input matInput [ngModel]="customer.address2" readonly />
      </mat-form-field>
    </div>
    <div class="row display-column-flex align-center">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'App.CustomerDetails.Placeholders.CityProvinceCountry' | translate }}</mat-label>
        <input matInput [ngModel]="customer.cityProvinceCountry" readonly />
      </mat-form-field>
    </div>
    <div class="row display-column-flex align-center">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'App.CustomerDetails.Placeholders.Status' | translate }}</mat-label>
        <input matInput [ngModel]="customer.subscriptionStatus" readonly />
      </mat-form-field>
    </div>
  </ng-container>
  <ng-template #loadingCustomerDetails>
    <div class="grid--center my--lg">
      <mat-spinner class="primary-spinner"></mat-spinner>
    </div>
  </ng-template>
</div>
<div class="row row--space-around" mat-dialog-actions>
  <button mat-button class="secondary-button column--6 rounded" (click)="onClose()">
    <span>{{ 'App.CustomerDetails.Buttons.Close' | translate }}</span>
  </button>
</div>
